module.exports = __webpack_public_path__ + "img/trading.ad6454c9.svg";